<template>
  <el-dialog :visible.sync="dialogVisible" title="Download Bot Report">
    <p>From here you can download Bot reports defined by your parameters to a CSV file.</p>
    <el-form ref="form" label-width="120px" :model="form" :rules="rules">
      <el-form-item label="File name" prop="fileName">
        <el-input v-model="form.fileName" />
      </el-form-item>
      <el-form-item label="Dates" prop="rangeDate">
        <el-date-picker
          type="daterange"
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date"
          v-model="form.rangeDate"
        />
      </el-form-item>
      <el-form-item label="Channels" prop="channels">
        <channel-select
          :channels="channelLinks"
          :selectedChannels="form.channels"
          @onSelectedChannelsChanged="handleSelectedChannelsChanged"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel" :disabled="isLoading">Cancel</el-button>
      <el-button type="primary" @click="handleRunDownloadReport" :disabled="isLoading">
        <i class="fa fa-spinner fa-spin" v-show="isLoading"></i>
        Download
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import gql from 'graphql-tag';
import ChannelSelect from '@/components/channel/ChannelSelect';
import { channelTypes } from '@/constants';

export default {
  name: 'BotReportDialog',
  components: {
    ChannelSelect,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    campaignId: {
      type: Number,
      required: true,
    },
    campaignTitle: {
      type: String,
      default: 'Campaign',
    },
    channelLinks: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    form: {
      fileName: '',
      rangeDate: [],
      channels: [],
      channel_types: [],
    },
    rules: {
      fileName: [
        { required: true, trigger: 'blur', message: 'Please enter a filename for this selection.' },
      ],

      rangeDate: [{ required: true, trigger: 'blur', message: 'Please enter a date range.' }],

      channels: [
        { required: true, trigger: 'change', message: 'Please select at least one channel.' },
      ],
    },
    channelList: [],
    isLoading: false,
  }),
  apollo: {
    channelList: {
      query: gql`
        {
          channelList(live: true) {
            id
            handle
            channelTypeTitle
          }
        }
      `,
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.isVisible;
      },
      set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      },
    },
  },
  methods: {
    async handleRunDownloadReport() {
      const valid = await this.$refs.form.validate().catch(() => false);
      if (!valid) return;

      const payload = {
        campaign_id: this.campaignId,
        channels: this.form.channels,
        channel_types: this.form.channel_types,
        file_name: this.form.fileName,
        date_from: this.form.rangeDate[0],
        date_to: this.form.rangeDate[1],
      };

      this.isLoading = true;

      try {
        await this.$store.dispatch('campaign/downloadBotReport', payload);
        this.$emit('onVisibleChanged', false);
      } finally {
        this.isLoading = false;
      }
    },

    handleSelectedChannelsChanged(selectedChannels) {
      this.form.channels = selectedChannels;
      const selectedChannelTypes = this.channelList
        .filter(channel => selectedChannels.includes(channel.id))
        .map(channel => channelTypes[channel.channelTypeTitle.toUpperCase()]);
      this.form.channel_types = new Set(selectedChannelTypes).toJSON();
    },

    handleCancel() {
      this.$emit('onVisibleChanged', false);
    },
  },
  mounted() {
    const filename = this.campaignTitle.replace(/[^\w\d]|[\s]/g, '-').toLowerCase();
    this.form.fileName = `${filename}-report`.replace(/-{2,}/g, '-');
  },
};
</script>



// WEBPACK FOOTER //
// BotReportDialog.vue?14694dac